<button [class]="class" [type]="type" mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
	[matTooltip]="tooltip" [color]="color" (click)="openMenu()" [disabled]="disabled">
	<mat-icon>{{icon}}</mat-icon>
</button>

<mat-menu class="padding-horizontal-sm menu-width-se-delete" #menu="matMenu">
	<div (click)="$event.stopPropagation()" class="overflow-hidden">

		<delete-child-enrollment-check *ngIf="isOpen" [students]="students" [schoolEnrollments]="schoolEnrollments"
			(setDoneLoading)="setDoneLoading($event)"></delete-child-enrollment-check>

		<hr />
		<div>
			<button [color]="popoverConfirmColor" mat-raised-button (click)="confirm()" #confirmElement tabindex="1000"
				[disabled]="!doneLoading || isDeleting || (msg && msg.SUCCESS!)">{{popoverConfirmText}}
				<mat-icon *ngIf="isDeleting">
					<mat-spinner diameter="20"> </mat-spinner>
				</mat-icon>
			</button>
			<!-- <button [color]="popoverCancelColor" mat-raised-button (click)="closeMenu()"
				tabindex="1001">{{popoverCancelText}}</button> -->
		</div>
		<app-msg [msg]="msg" *ngIf="msg"></app-msg>
	</div>
</mat-menu>